import StateFormSelect from './StateFormSelect';

export default function DeliveryAddressForm(props) {
    const { onAddressChange, shippingRequired, deliveryAddress = {} } = props;
    
    const handleAddressChange = (field, value) => {
        // Clear any previous custom validity when user changes address fields
        if (field === 'address' || field === 'address2') {
            const inputElement = document.getElementById(field === 'address' ? 'deliveryaddress' : 'deliveryaddress2');
            if (inputElement) {
                inputElement.setCustomValidity('');
                inputElement.classList.remove('is-invalid');
            }
        }
        
        // Pass the change up to parent
        if (onAddressChange) {
            onAddressChange(field, value);
        }
    };
    
    return (
        <div className={props.show ? "row g-3" :'d-none'}>
            {/*<div className="contain-div">*/}
            <div className="col-sm-6">
                <label htmlFor="deliveryfirstName" className="form-label">First name</label>
                <input type="text" className="form-control" id="deliveryfirstName" placeholder=""
                    value={deliveryAddress.firstName || ''}
                    required={props.show} onChange={(e) => handleAddressChange('firstName', e.target.value)} />
                <div className="invalid-feedback">
                    Valid first name is required.
                </div>
            </div>
            <div className="col-sm-6">
                <label htmlFor="deliverylastName" className="form-label">Last name</label>
                <input type="text" className="form-control" id="deliverylastName" placeholder=""
                    value={deliveryAddress.lastName || ''}
                    required={props.show} onChange={(e) => handleAddressChange('lastName', e.target.value)} />
                <div className="invalid-feedback">
                    Valid last name is required.
                </div>
            </div>
            <div className="col-12">
                <label htmlFor="deliveryaddress" className="form-label">Address</label>
                <input type="text" className="form-control" id="deliveryaddress" placeholder="1234 Main St"
                    value={deliveryAddress.address || ''}
                    required={props.show} onChange={(e) => handleAddressChange('address', e.target.value)} />
                <div className="invalid-feedback">
                    Please enter your delivery address. PO Boxes cannot be used for shipping.
                </div>
            </div>
            <div className="col-12">
                <label htmlFor="deliveryaddress2" className="form-label">Address 2 <span
                    className="text-muted">(Optional)</span></label>
                <input type="text" className="form-control" id="deliveryaddress2"
                    value={deliveryAddress.address2 || ''}
                    placeholder="Apartment or suite" onChange={(e) => handleAddressChange('address2', e.target.value)} />
            </div>

            <div className="col-md-5">
                <label htmlFor="deliverycountry" className="form-label">Country</label>
                <select className="form-select" id="deliverycountry"
                    required={props.show}>

                    <option value="">Choose...</option>
                    <option>United States</option>
                </select>
                <div className="invalid-feedback">
                    Please select a valid country.
                </div>
            </div>

            <StateFormSelect id="deliverystate" isRequired={props.show} value={deliveryAddress.state || ''} onChange={(e) => handleAddressChange('state', e.target.value)} />
            <div className="col-md-3">
                <label htmlFor="deliverycity" className="form-label">City</label>
                <input type="text" className="form-control" id="deliverycity" placeholder=""
                    value={deliveryAddress.city || ''}
                    required={props.show} onChange={(e) => handleAddressChange('city', e.target.value)} />
                <div className="invalid-feedback" >
                    City required.</div>
            </div>
            <div className="col-md-3">
                <label htmlFor="deliveryzip" className="form-label">Zip</label>
                <input type="text" className="form-control" id="deliveryzip" placeholder=""
                    value={deliveryAddress.zip || ''}
                 required={props.show} onChange={(e) => handleAddressChange('zip', e.target.value)} />
                <div className="invalid-feedback" >
                    Zip code required.
                </div>
            </div>
        </div>
        )
}